import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Avatar} from 'shared/components';

const RequestSummary = observer(({uiState}) => {
  const {request} = uiState;

  return (
    <div className='flex justify-content-between'>
      <div className='flex align-items-center gap-2'>
        <Avatar employee={request.employee} />
        <div>
          <span className='h3'>
            {request.employee.name}
          </span>
          <div className='jumbo'>
            <FormattedMessage
              id='expenses.expense_requests.detail.SUBMITTED'
              values={{date: request.createdAtView}}
            />
          </div>
        </div>
      </div>
      <span className='h1'>{request.amountView}</span>
    </div>
  );
});

export default RequestSummary;
